import type { ColumnDef, RowData } from '@/lib/tanstack-table';

const UNSORTABLE = Symbol('unsortable-column');

/** A column that has explicitly opted out of sorting. */
export type UnsortableColumn<TData extends RowData> = ColumnDef<TData> & {
  readonly [UNSORTABLE]: true;
};

/**
 * Opts a column out of sorting. Columns sort by default and the
 * `custom/sortable-columns` lint rule rejects a bare `enableSorting: false`,
 * so this is the one way to ship a column without a sort: for utility columns
 * (select, actions) and for values the server can't order by yet.
 */
export function unsortableColumn<TData extends RowData>(
  column: ColumnDef<TData>,
): UnsortableColumn<TData> {
  return { ...column, enableSorting: false, [UNSORTABLE]: true };
}

export function isUnsortableColumn<TData extends RowData>(
  column: ColumnDef<TData>,
): column is UnsortableColumn<TData> {
  return UNSORTABLE in column;
}
